import React, { Component } from 'react';

import IconArrowLeft from '../../assets/icons/IconArrowLeft';

class PreviousPageButton extends Component {
    render() {
        return (
            <button type="button" id="btnpreviouspage" className="flex justify-center items-center h-8 w-8 mr-1 rounded bg-white text-gray-400 outline-none focus:outline-none">
                <IconArrowLeft />
            </button>
        );
    }
}

export default PreviousPageButton;